const organization_pt = require('./organization.json')
export default organization_pt